// Helpers puros da gestão de anúncios da Meta (pausar, ativar, orçamento): sem React e sem rede.
// A permissão e o limite por hora ficam no backend; o valor do orçamento é decisão do usuário.

export const STATUS_LABELS = { ACTIVE: 'Ativo', PAUSED: 'Pausado' }
export const LEVEL_LABELS = { campaign: 'campanha', adset: 'conjunto', ad: 'anúncio' }
export const BUDGET_LABELS = { daily_budget: 'orçamento diário', lifetime_budget: 'orçamento vitalício' }

const money = (value, currency) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: currency || 'BRL' }).format(value || 0)

// Variação percentual entre o orçamento atual e o novo. Null quando não há base.
export function budgetChangePct(before, after) {
  const base = Number(before)
  const next = Number(after)
  if (!(base > 0) || !Number.isFinite(next)) return null
  return ((next - base) / base) * 100
}

// "12,5" ou "1.250,50" -> 12.5 / 1250.5. Vazio ou inválido vira null.
export function parseAmount(text) {
  const raw = String(text ?? '').trim()
  if (!raw) return null
  const normalized = raw.includes(',') ? raw.replace(/\./g, '').replace(',', '.') : raw
  const value = Number(normalized)
  return Number.isFinite(value) && value > 0 ? value : null
}

// Próximo status ao clicar no botão da linha. A tabela guarda 'active' | 'paused'.
export function nextStatus(rowStatus) {
  return rowStatus === 'active' ? 'PAUSED' : 'ACTIVE'
}

// Prévia devolvida pelo backend -> linhas "antes / depois" para o modal.
export function describePreview(preview) {
  if (!preview) return null
  const { action, before = {}, after = {}, currency } = preview
  const name = preview.name || 'Item'
  if (action === 'duplicate') {
    return {
      title: 'Duplicar campanha',
      name,
      from: 'Campanha atual',
      to: 'Cópia pausada',
      note: 'A cópia leva os conjuntos e anúncios, todos pausados.',
    }
  }
  if (action === 'status') {
    return {
      title: after.status === 'PAUSED' ? `Pausar ${LEVEL_LABELS[preview.level]}` : `Ativar ${LEVEL_LABELS[preview.level]}`,
      name,
      from: STATUS_LABELS[before.status] || before.status,
      to: STATUS_LABELS[after.status] || after.status,
      note: after.status === 'ACTIVE' ? 'Ativar volta a gastar o orçamento da campanha.' : null,
    }
  }
  const kind = 'daily_budget' in after ? 'daily_budget' : 'lifetime_budget'
  const pct = budgetChangePct(before[kind], after[kind])
  return {
    title: `Ajustar ${BUDGET_LABELS[kind]}`,
    name,
    from: money(before[kind], currency),
    to: money(after[kind], currency),
    note: pct === null ? null : `${pct >= 0 ? '+' : ''}${pct.toFixed(0)}% sobre o valor atual`,
  }
}
